import React from 'react';
import PropTypes from 'prop-types';


import styles from '../../containers/checkoutPage/CheckoutPage.m.sass';

import {required} from '../../utils/validators';

import {Field} from 'redux-form';

import FieldText from '../fields/fieldText/FieldText';
import FieldSelect from '../fields/fieldSelect/FieldSelect';


export default class CharacterFields extends React.PureComponent {
  render() {
    return (
      <fieldset className={styles.checkout_group}>
        <legend className={styles.checkout_legend}>Character information</legend>
        <div className={styles.checkout_fieldsRow}>
          <div className="col-md-6">
            <Field
              component={FieldText}
              type="text"
              label="Character Name"
              name="Character Name"
              placeholder="Your ingame character name"
              validate={required}
            />
          </div>

          <div className="col-md-6">
            <Field
              component={FieldText}
              type="text"
              label="Server Name"
              name="Server Name"
              placeholder="Your ingame server name"
              validate={required}
            />
          </div>

          <div className="col-md-6">
            <Field
              component={FieldText}
              type="text"
              label="Battle tag"
              name="Battle tag"
              placeholder="e.g. mytag#1234"
              validate={required}
            />
          </div>

          <div className="col-md-6">
            <Field
              component={FieldSelect}
              className={styles.checkout_fieldInline}
              type="text"
              label="Faction"
              name="Faction"
              placeholder="e.g. mytag#1234"
            >
              <option value="Alliance">Alliance</option>
              <option value="Horde">Horde</option>
            </Field>
          </div>
        </div>
      </fieldset>
    );
  }
}



// WEBPACK FOOTER //
// ./components/checkout/CharacterFields.js